"use strict";
// Copyright © Veeam Software Group GmbH
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AddToPolicyResultDialog = void 0;
const react_1 = __importDefault(require("react"));
const components_1 = require("@veeam/components");
const core_1 = require("../../../../../core");
const components_2 = require("../../../../../components");
const helpers_1 = require("./helpers");
require("./types");
const AddToPolicyResultDialog = ({ gridData, onDeactivate, onDone, texts, }) => {
    const { t } = core_1.useFeatureContext();
    const handleDone = () => {
        onDeactivate();
        onDone === null || onDone === void 0 ? void 0 : onDone();
    };
    return (react_1.default.createElement(components_1.Dialog, { id: "addToPolicyResultDialog", header: (texts === null || texts === void 0 ? void 0 : texts.resultDialogHeader) || t('addToPolicyDialog|resultDialog|header'), size: {
            width: components_1.DIALOG_SIZE.l,
            height: components_1.DIALOG_SIZE.l,
        }, hasTopPadding: false, onRequestClose: handleDone, actions: [
            {
                id: 'add',
                view: components_1.ACTION_VIEW.primary,
                text: t('addToPolicyDialog|resultDialog|actions|ok'),
                onClick: handleDone,
            },
        ] },
        react_1.default.createElement(components_1.StackView, { spaceTop: components_1.VIEW_INDENT.s },
            react_1.default.createElement(components_2.Grid, { id: "addToPolicyResultGrid", data: gridData, columns: helpers_1.getColumns({
                    id: (texts === null || texts === void 0 ? void 0 : texts.resultColumnIdTitle) ||
                        t('addToPolicyDialog|resultDialog|grid|columns|id|title'),
                    policyName: (texts === null || texts === void 0 ? void 0 : texts.resultColumnPolicyTitle) ||
                        t('addToPolicyDialog|resultDialog|grid|columns|policy|title'),
                    resourceName: (texts === null || texts === void 0 ? void 0 : texts.resultColumnResourceTitle) ||
                        t('addToPolicyDialog|resultDialog|grid|columns|resourceName|title'),
                    result: (texts === null || texts === void 0 ? void 0 : texts.resultColumnResultTitle) ||
                        t('addToPolicyDialog|resultDialog|grid|columns|result|title'),
                }) }))));
};
exports.AddToPolicyResultDialog = AddToPolicyResultDialog;
//# sourceMappingURL=AddToPolicyResultDialog.js.map